<div class="integrations-wrapper">
	<meta-integrations-block></meta-integrations-block>

	<email-integration-card
		[mailboxes]="mailboxes"
		[emailsLimit]="emailsLimit"
		[loading]="loading"
		(connect)="linkMailbox()"
		(unlink)="onUnlink($event)"
		(upgrade)="onUpgrade()"
	></email-integration-card>

	<tiktok-integration
		[anaSetting]="'integrations.tiktok'"
		[data]="tiktokData"
		[limit]="tiktokLimit"
		[loading]="tiktokLoading"
		(upgrade)="onUpgrade()"
	></tiktok-integration>

	<chat-channels-block></chat-channels-block>

	<app-google-disclosure></app-google-disclosure>
</div>
